export const roleUserVerification = (
  roleToCheck: string[] | undefined,
  permissionsValid: string[],
) => {
  if (permissionsValid.length === 0) return true;
  return roleToCheck?.some((role) => permissionsValid.includes(role));
};
